import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'container', 'backdrop' ]

  connect() {
    this.toggleClass = '-left-full'
    this.closeEvent = 'popupClosed'
    this.openEvent = 'popupOpened'
    this.element[this.identifier] = this
  }

  open(e) {
    e.preventDefault()

    this.containerTarget.classList.remove(this.toggleClass)
    this.backdropTarget.classList.remove('hidden')
    this.trigger(this.openEvent)
  }

  close(e) {
    e.preventDefault()

    this.containerTarget.classList.add(this.toggleClass)
    this.backdropTarget.classList.add('hidden')
    this.trigger(this.closeEvent)
  }

  closeWithEsc(e) {
    if (e.keyCode === 27 && !this.containerTarget.classList.contains(this.toggleClass)) {
      this.close(e);
    }
  }

  trigger(eventName) {
    const event = new CustomEvent(eventName, { bubbles: true })
    window.dispatchEvent(event)
  }
}
